
import { Component, Vue, Prop } from "vue-property-decorator";
import UserReviewRequestIcon from "./UserReviewRequestIcon.vue";

@Component({
  components: {
    UserReviewRequestIcon
  }
})
export default class UserReviewIcon extends Vue {
  @Prop() approved!: boolean;
  @Prop() canAssign!: boolean;
  @Prop() canRemove!: boolean;
  @Prop() requested!: boolean;
  @Prop() canRequest!: boolean;

  public hovered = false;

  public removeClicked() {
    this.$emit("remove-clicked");
  }

  public assignClicked() {
    this.$emit("assign-clicked");
  }
}
